export enum EmptyStateOnColor {
  onwhite = 'onwhite',
  onblueberry = 'onblueberry',
  oncherry = 'oncherry',
}
